import { createContext, useContext } from 'react';

export const ThemeModeContext = createContext({
  mode: 'dark',
  toggleColorMode: () => {},
});

export function useThemeMode() {
  return useContext(ThemeModeContext);
}
